module.exports = __webpack_public_path__ + "static/darmiento-trophy-5b7b14d533a1fc5fde514f36b31dfe2a.jpg";